import {
	ImageParams,
	DocumentType,
	ImageScale,
} from '@front-app/services/ImageApi/ImageModel';
import { atobUtf8 } from '@front-app/util/string';

export interface TRImage {
	src: string | null;
	params: ImageParams | null;
}

/**
 * This takes in an unsanitized `src` string from the API and decodes it into
 * EITHER:
 * 1) A valid "src" string representing a URL where an image can be loaded OR
 * 2) Into an ImageParams data object that can later be used to fetch an image from the API
 *
 * @param src A string which could be any of: base64 encoded external URL,
 * a URL parameter string, other?
 */
export function parseApiSrc(src: string): TRImage {
	const decodedSrc = decodeSrc(src);
	if (decodedSrc) {
		return {
			src: decodedSrc,
			params: null,
		};
	}
	return {
		src: null,
		params: srcStringToImageParams(src),
	};
}

function decodeSrc(src: string) {
	try {
		const decodedSrc = atobUtf8(src);
		return decodedSrc.match('^http') ? decodedSrc : null;
	} catch (e) {
		return null;
	}
}

const DEFAULT_PARAMS = {
	pt: DocumentType.IMAGE_AVATAR,
	sc: ImageScale.LARGE_2X,
	md: '',
	sd: '',
	dr: '',
};

function srcStringToImageParams(
	src: string,
	overrideParams?: Partial<ImageParams>,
): ImageParams {
	const values = new URLSearchParams(src);
	return {
		pt: values.get('pt') as DocumentType || DEFAULT_PARAMS.pt,
		sc: values.get('sc') as ImageScale || DEFAULT_PARAMS.sc,
		md: values.get('md') || DEFAULT_PARAMS.md,
		sd: values.get('sd') || DEFAULT_PARAMS.sd,
		dr: values.get('dr') || DEFAULT_PARAMS.dr,
		...overrideParams,
	};
}
